<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    // 统一渲染图标占位容器，保证无论有无图标，菜单文字都在同一水平线对齐
    if (icon) {
      // el-icon- 开头 → Element UI 图标；否则 → 自管理 SVG Sprite
      if (icon.startsWith('el-icon-')) {
        vnodes.push(<i class={['menu-icon-wrap', icon]}></i>)
      } else {
        vnodes.push(<i class="menu-icon-wrap"><svg-icon icon-class={icon}/></i>)
      }
    } else {
      vnodes.push(<i class="menu-icon-wrap"></i>)
    }

    if (title) {
      if (title.length > 5) {
        vnodes.push(<span slot='title' title={(title)}>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>
